
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.6 9.73L7 7.403 9.4 9.73l.934-.904-2.4-2.325 2.4-2.325-.934-.904L7 5.596 4.6 3.27l-.933.904 2.4 2.325-2.4 2.325.933.904zM7 12.957a6.75 6.75 0 01-4.717-1.89A6.515 6.515 0 01.859 9.02 6.12 6.12 0 01.333 6.5c0-.893.175-1.733.525-2.519.35-.785.826-1.469 1.425-2.05A6.749 6.749 0 014.4.55 6.673 6.673 0 017 .04c.922 0 1.789.17 2.6.51.811.338 1.517.798 2.117 1.38a6.515 6.515 0 011.425 2.05 6.12 6.12 0 01.525 2.519 6.12 6.12 0 01-.525 2.519 6.515 6.515 0 01-1.425 2.05A6.75 6.75 0 019.6 12.45a6.674 6.674 0 01-2.6.51z"}})])
          )
        }
      }
    